import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'axle-primary-button',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './axle-primary-button.component.html'
})
export class AxlePrimaryButtonComponent {
  @Input() loading?: boolean = false;
  @Input() disabled?: boolean = false;
  @Input() text?: string;
  @Input() size?: 'regular' | 'large' = 'regular';

  @Output() clicked = new EventEmitter<void>();

  buttonClicked() {
    this.clicked.emit();
  }
}
